import React from 'react';
import { useProfile, getUtmSource } from 'providers/profile.provider';
import { useProduct } from 'providers/product.provider';
import { getPartnerLogoClass } from 'utils/product-utils';
import bizLogo from 'assets/img/biz-capital-logo-2019.png';
import poligonoLogo from 'assets/img/poligono.png';
import { POLIGONO_BRAND, getProductBrand } from 'constants/brand-constants';

const check =
    '<svg xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6"><path fill="#FFF" fill-rule="nonzero" d="M1.648 2.382A1 1 0 0 0 .352 3.906l2.184 1.856a1 1 0 0 0 1.371-.072l3.817-4A1 1 0 0 0 6.277.31L3.112 3.627 1.648 2.382z"/></svg>';

export const PartnerLogo = ({ url }) => {
    const { loanApplicationUtmSource } = useProfile();
    const { productBizId } = useProduct();

    const partnersLogoClass = getPartnerLogoClass(getUtmSource(), productBizId, loanApplicationUtmSource);

    return (
        <div className="partner-logo-container">
            <img src={url} className={partnersLogoClass} />
        </div>
    )
};

export const MobileSteps: React.FC<{ elements: any[] }> = ({
    elements,
}): JSX.Element => (
    <>
        {elements.map((step, key: number) => (
            <React.Fragment key={key}>
                <span
                    className={step.className}
                    dangerouslySetInnerHTML={{
                        __html: step.className === 'completed' ? check : '',
                    }}
                />
                {step.className === 'active' && (
                    <label>{step.label}</label>
                )}
            </React.Fragment>
        ))}
    </>
);

export const DesktopSteps: React.FC<{ elements: any[] }> = ({
    elements,
}): JSX.Element => (
    <>
        {elements.map(({ label, className }, key: number) => (
            <div className={className} key={key}>
                <span
                    className="bullet"
                    dangerouslySetInnerHTML={{
                        __html: className === 'completed' ? check : '',
                    }}
                />
                <label>{label}</label>
            </div>
        ))}
    </>
);

export const PartnerHeaderStyle = ({ partnerUrl }) => (
    <nav className="header">
        <div className="inner">
            <PartnerLogo url={partnerUrl} />
        </div>
        <div className="partner-header-separator" />
    </nav>
);

export const DefaultHeaderStyle = () => {
    const isPoligono = getProductBrand().branchName === POLIGONO_BRAND.branchName;

    return (
        <nav className="header">
            <div className="inner">
                <img
                    src={isPoligono ? poligonoLogo : bizLogo}
                    className={isPoligono ? 'poligono-logo bizcap-logo' : 'bizcap-logo'}
                />
            </div>
        </nav>
    );
};

export const LoadingContainer: React.FC = (): JSX.Element => (
    <nav className="header">
        <div className="inner" />
    </nav>
);
